import axios from 'axios'
import config from '../config/dev.json'

let path = '/api/v1'
let url = config.host + path
let urlSecure = config.host + path +'/secure'
import production from '../config/production.json'
import Vue from 'vue';

if (process.env.NODE_ENV === 'production') {
  let url = config.host + path
  let urlSecure = config.host + path +'/secure'
}
export async function FacebookLogin(token) {
  return new Promise((resolve, reject) => {
    axios.post(url + '/facebook/login', {
      token
    }).then((response) => {
      resolve(response)
    }).catch(err => reject(err))
  })
}

export async function FacebookLogout () {
  return new Promise((resolve, reject) => {
    axios.post(url + '/facebook/logout').then((response) => {
      localStorage.clear();
      resolve(response.data.data)
    }).catch(err => reject(err))
  })
}
 export async function forget(email){
  return new Promise((resolve, reject) => {
    console.log("mail auth service",{email})
    axios.post(url + '/auth/forget', {email}).then((response) => {
      resolve(response)
    }).catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err.response.data.errors)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: err.response.data.errors,
              type: "danger"
            })
          );
    })
  }) 
}
export async function login(user){
  return new Promise((resolve, reject) => {
    axios.post(url + '/auth/login', user).then((response) => {
      localStorage.token = response.data.data.token
      let token = localStorage.token;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      resolve(response.data.data.user)
    }).catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err.response.data.errors)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: err.response.data.errors,
              type: "danger"
            })
          );
    })
  }) 
}

export async function register(user){
  console.log("test userregister")
  return new Promise((resolve, reject) => {
    axios.post(url + '/auth/register', user).then((response) => {
        localStorage.token = response.data.data.token
        let token = localStorage.token;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      resolve(response.data.data.user)
    }).catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err.response.data.errors)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: err.response.data.errors,
              type: "danger"
            })
          );
    })
  })
}

export async function logout(){
  return new Promise((resolve, reject) => {
    axios.get(url + '/auth/logout').then((response) => {
      localStorage.clear();
      resolve(response)
    }).catch(err=> reject(err))
  })
}

export async function getInfo() {
  return new Promise((resolve, reject) => {
    axios.get(urlSecure + '/profile/info').then((response) => {
      resolve(response.data.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export async function refresh() {
  return new Promise((resolve, reject) => {
    if( localStorage.token) {
      let token = localStorage.token
      setToken(token)
      axios.get(urlSecure + '/profile/refresh').then((response) => {
        localStorage.token = response.data.data
        let token = localStorage.token
        setToken(token)
        resolve(token)
      }).catch(err => reject(err))
    } else {
      reject ('logout and login again')
    }
  })
}

export async function setToken(token) {
  axios.defaults.headers['Authorization']  = 'Bearer ' + token
}

export async function getLanguage() {
  return new Promise((resolve, reject) => {
    axios.get("https://restcountries.eu/rest/v1/all").then((response) => {
      let countries = new Array();
      response.data.forEach(element => {
        countries.push(element.name);
      });
      resolve(countries);
    }).catch(err => reject(err));
  })
}


// WEBPACK FOOTER //
// ./src/api/auth.service.js